import React from 'react';

const Price = (props) => {
    const totalOrder = props.order.reduce((total, count) => total + count.count, 0)
    const price = props.order.reduce((total, product) => total + product.price * product.count, 0)
    const tax = price * 0.1
    return (
        <div className="d-flex">
            <div className="col-md-8">
            <p>Subtotal | {totalOrder} item</p>
            <p>Tax</p>
            <p>Delivery fee</p>
            <h5>Total</h5>
            </div>
            <div className="col-md-4">
                <p>${price}</p>
                <p>${tax.toFixed(2)}</p>
                <p>free</p>
                <p>${(price + tax).toFixed(2)}</p>
            </div>
        </div>
    );
};

export default Price;